import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import GoogleMapView from "../GoogleMapView";
import useIsMobile from "../../hooks/useIsMobile";
import AffichageRealisationsPresta from "../AffichageRealisationsPresta";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export default function UserDonneurOrdreForAdmin({ donneurOrdre }) {
    const dispatch = useDispatch();
    const { user, token } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const fileInputRef = useRef(null);
    const [localDonneurOrdre, setLocalDonneurOrdre] = useState(donneurOrdre);

    const apiUrl = process.env.REACT_APP_API_URL;

    // ❗Ce hook doit être avant tout "return"
    const isMobile = useIsMobile(768);



    const [activeTab, setActiveTab] = useState("infos");
    const [openAccordion, setOpenAccordion] = useState(null);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [typePhoto, setTypePhoto] = useState(null);

    // 🔥 Seulement maintenant : on peut retourner null
    if (!donneurOrdre) return null;

    const getNameStatut = (idStatut) => {
        switch (idStatut) {
            case "micro-entrepreneur":
                return "Micro-entrepreneur (ME)";
            case "eirl":
                return "Entreprise Individuelle (EI)";
            default:
                return idStatut.toUpperCase();
        }
    };

    const tabList = [
        { id: "infos", label: "Informations personnelles" },
        { id: "entreprise", label: "Entreprise" },
        { id: "localisation", label: "Localisation" },
  

    ];

    const handlePhotoClick = () => {
        fileInputRef.current?.click();
    };

    const handlePhotoChange = async (e) => {
        const file = e.target.files[0];

        if (!file) return;

        try {
            const formData = new FormData();
            formData.append("idDonneurOrdre", donneurOrdre.idProfilDonneurOrdre);
            formData.append("logo", file);

            const response = await fetch(
                `${apiUrl}/api/admin/updateLogoDonneurOrdre`,
                {
                    method: "POST",
                    headers: {
          "Authorization": `Bearer ${token}`,
        },
                    body: formData,
                    
                }
            );

            const data = await response.json();
          const fileName = data.fileName;

setLocalDonneurOrdre((prev) => {
    
        return {
            ...prev,
            logo: fileName
        };
    
});
            if (!response.ok) {
                throw new Error(data.error || "Erreur lors de l'upload");
            }

          

        } catch (error) {
            console.error(error);
            alert(error.message);
        }

        // Permet de sélectionner à nouveau le même fichier
        e.target.value = "";
    };

    return (
        <>
            <div className="profil-wrapper">
                                           <input
    ref={fileInputRef}
    type="file"
    accept="image/*"
    style={{ display: "none" }}
    onChange={handlePhotoChange}
/>
                {/* Desktop Tabs */}
                {!isMobile && (
                    <div style={{ display: "flex", gap: "12px", margin: "auto",marginTop:"15px", justifyContent: "center" }}>
                        {tabList.map((tab) => (
                            <button
                                key={tab.id}
                                style={{
                                    padding: "8px 14px",
                                    cursor: "pointer",
                                    borderRadius: "6px",
                                    background: activeTab === tab.id ? "#007bff" : "#f1f1f1",
                                    color: activeTab === tab.id ? "white" : "#333",
                                    border: "none",
                                }}
                                onClick={() => setActiveTab(tab.id)}
                            >
                                {tab.label}
                            </button>
                        ))}

                    </div>
                )}

                {/* Mobile Dropdown */}
                {isMobile && (
                    <div style={{ marginTop: "20px", marginBottom: "15px" }}>
                        <button
                            style={{ padding: "10px", borderRadius: "6px", background: "#f1f1f1", width: "100%" }}
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        >
                            {tabList.find((t) => t.id === activeTab)?.label} ▾
                        </button>
                        {mobileMenuOpen && (
                            <div style={{ marginTop: "10px", border: "1px solid #ddd", borderRadius: "6px", background: "#fafafa" }}>
                                {tabList.map((tab) => (
                                    <div
                                        key={tab.id}
                                        style={{ padding: "12px", cursor: "pointer" }}
                                        onClick={() => {
                                            setActiveTab(tab.id);
                                            setMobileMenuOpen(false);
                                        }}
                                    >
                                        {tab.label}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}

                <div className="profil-content">
                    {activeTab === "infos" && (
                        <div className="profil-section-card">
                             
                            <p><strong>Nom :</strong> {donneurOrdre.nomDonneurOrdre}</p>
                            <p><strong>Prénom :</strong> {donneurOrdre.prenomDonneurOrdre}</p>
                            <p><strong>Téléphone :</strong> {donneurOrdre.telephoneDonneurOrdre}</p>

                        </div>
                    )}

                    {activeTab === "entreprise" && (
                        <div className="profil-section-card">
                            {localDonneurOrdre?.logo && (
                                <div className="profil-photo-container">
                                    <img
                                        className="profil-photo"
                                        src={
                                            apiUrl +
                                            "/api/files/?categorie=logos&file=" +
                                            localDonneurOrdre?.logo +
  "&t=" + Date.now()
                                        }
                                        alt="Logo"
                                    />
                                </div>
                            )}
                            <button className="btn-primary" onClick={()=>handlePhotoClick()}>{localDonneurOrdre.logo?"MODIFIER LE ":"AJOUTER UN "}LOGO</button>
                            <p><strong>Raison sociale :</strong> {donneurOrdre.raisonSocialeEntreprise}</p>
                            <p><strong>Secteur d'activité principal :</strong> {donneurOrdre.secteur.labelSecteur}</p>
                            <p><strong>SIRET :</strong> {donneurOrdre.siretEntreprise}</p>
                            <p><strong>TVA :</strong> {donneurOrdre.numTvaEntreprise}</p>
                           



                        </div>
                    )}
                    
                    {activeTab === "localisation" && (
                        <div className="profil-section-card">

                            <p><strong>Adresse :</strong> {donneurOrdre.adresseFacturation.ligne1}</p>
                            <p><strong>Code postal :</strong> {donneurOrdre.adresseFacturation.codePostal}</p>
                            <p><strong>Ville :</strong> {donneurOrdre.adresseFacturation.ville}</p>
                            <p><strong>Pays :</strong> France</p>
                            
                            {/* <GoogleMapView origin={{ lat: prestataire.latitudePrestataire, lng: prestataire.longitudePrestataire }} /> */}


                        </div>
                    )}
                    
                </div>
            </div>


        </>
    );
}
